<div class="card">
    <div class="card-title" style="background-color: #f1b44c;">
        <div class="card-header" style="text-align: center; color: #010179;"> Modifier votre photo du profil </div>

    </div>
    <div class="card-header" style="text-align: center; ">
        <div class="col-sm-8">
            <div class="card-body">
                <div class="float-end mt-4">
                    <!-- <img [src]="'data:image/png;base64,'+ image" width="150px" height="100px" alt="Image" /> -->
                    <img [src]="imagePreview" width="150px" height="150px" alt="Image" />
                </div>
                <p class="text-muted mt-3 mb-0"> <b> Votre photo : </b> </p>
                <br> <br> <br> <br><br> <br><br>  
                <div class="mx-auto" style="width:600px;">
                    <label for="name" class="text-muted mt-3 mb-0">Importer votre photo :</label> &nbsp;
                    <input id="name" name="name" (change)="fileChange($event)" id="" type="file" />
                </div>
            </div>
            <!-- <img  [src]="'data:image/png;base64,'+ logo"  width="100%"  height="100%" /> -->
            <!-- img [src]="'data:image/png;base64,'+ image" width="50px" -->
            <!--  -->
        </div>
    </div>

    <div class="col-md-12 text-right">
        <button class="btn btn-primary pull-right" style="margin-bottom: 15px; margin-right: 15px;" (click)="fermer()">
            <div style="font-weight: bold;">Fermer</div>
        </button>
        <button type="button" class="btn btn-success pull-right" style="margin-bottom: 15px; margin-right: 15px;"
            (click)="update()">
            <div style="font-weight: bold;">Modifier</div>
        </button>
    </div>
</div>